import { useMutation } from '@tanstack/react-query';

interface DeleteProvidedJobPostParams {
  id: number;
}

export default function useDeleteProvidedJobPost() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async ({ id }: DeleteProvidedJobPostParams): Promise<void> => {
      const response = await fetch(`/agent/api/provided_job_posts/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to delete provided job post');
      }
    },
  });
}
